import Vue from 'vue'
import vSelect from 'vue-select'
import './Select.scss'

export const Select = Vue.component('v-select', vSelect)
export default Select
